const checkUiRights = (uiRights, accessKey) => {
  if (accessKey == null) return true;
  return !!uiRights?.[accessKey];
};

export default checkUiRights;
